<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.1836 13.7943H13.5469V21.6693H10.0312V13.7943H7.14844V10.5599H10.0312V8.06384C10.0312 5.25134 11.7188 3.66931 14.2852 3.66931C15.5156 3.66931 16.8164 3.91541 16.8164 3.91541V6.69275H15.375C13.9688 6.69275 13.5469 7.5365 13.5469 8.45056V10.5599H16.6758L16.1836 13.7943Z"
            fill="inherit"
        />
    </svg>
</template>
